import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import { Check, Fuel } from "lucide-react";
import closeModal from "../../assets/images/closeModal.svg";
import "../DesignationLevel/DynamicModal.css";
import TextField from "../designSystem/TextField";
import CancelButton from "../subComponents/buttons/CustomCancelButton";
import PrimaryButton from "../subComponents/buttons/PrimaryButton";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import fuelService from "../../services/fuel.service";
import { t } from "../../locales/translate";
const EditFuelRateModal = ({ onClose, editData, onSave }) => {
  const [price, setPrice] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (editData?.price != null) {
      setPrice(String(editData.price));
    }
  }, [editData]);

  const handleSave = async (e) => {
    e.preventDefault();
    const parsed = parseFloat(price);
    if (!price || Number.isNaN(parsed) || parsed <= 0) {
      setError(t("invalidFuelRate"));
      return;
    }
    setError("");
    setLoading(true);
    try {
      const response = await fuelService.saveFuelPrice({
        id: editData?.id ?? 0,
        price: parsed,
      });
      if (response.data?.status) {
        onSave(response.data.result?.[0] ?? { id: editData?.id, price: parsed });
      }
    } catch (err) {
      console.error("Error saving fuel price:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dynamicmodal-overlay">
      <div className="dynamicmodal-container overlay-wrapper">
        <LoadingOverlay isVisible={loading} />
        <div className={loading ? "blur" : ""}>
          <div className="dynamicmodal-header mb-3">
            <div className="dynamicmodal-header-left">
                <div className="icon fuel-modal-icon" id="fuel-modal-icon">
                <Fuel color="white" size={24} />
                </div>
              <div className="text">
                <h2 className="modalheading">{t("editFuelRate")}</h2>
              </div>
            </div>
            <div className="dynamicmodal-header-right">
              <IconButton onClick={onClose}>
                <img src={closeModal} alt="" />
              </IconButton>
            </div>
          </div>

          <form onSubmit={handleSave}>
            <div className="dynamicmodal-body">
              <TextField
                name="price"
                label={`${t("pricePerLiter")} *`}
                type="number"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder={t("input")}
                error={error}
              />
            </div>
            <div className="dynamicmodal-footer">
              <CancelButton onClick={onClose} text={t("cancel")} />
              <PrimaryButton text={t("save")} icon={Check} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditFuelRateModal;
